<template>
  <div id="sections-defences-armor-class-details-pfrpg">
    <div class="content" v-if="toggleState" style="clear:left;">
      <h4 class="header-bar">Armor Details</h4>
      <armor-detail :armorClass="armorClass.armor">Armor</armor-detail>

      <div class="row">
        <div class="col-2 text-center">
        </div>
        <div class="col text-center">
          <under-input v-model.number="armorClass.armor.maxDex" maxlength="2">
            Max Dex
          </under-input>
        </div>
        <div class="col text-center">
          <under-input v-model.number="armorClass.armor.checkPenalty" maxlength="2">
            Penalty
          </under-input>
        </div>
        <div class="col text-center">
          <under-input v-model.trim="armorClass.armor.spellFail" maxlength="3">
            Spell Fail
          </under-input>
        </div>
        <div class="col text-center">
          <under-input v-model.trim="armorClass.armor.speed" maxlength="6">
            Speed
          </under-input>
        </div>
      </div>
      <armor-detail :armorClass="armorClass.shield">Shield</armor-detail>
      <div class="row">
        <div class="col-2 text-center">
        </div>
        <div class="col text-center">
          <under-input v-model.number="armorClass.shield.maxDex" maxlength="2">
            Max Dex
          </under-input>
        </div>
        <div class="col text-center">
          <under-input v-model.number="armorClass.shield.checkPenalty" maxlength="2">
            Penalty
          </under-input>
        </div>
        <div class="col text-center">
          <under-input v-model.trim="armorClass.shield.spellFail" maxlength="3">
            Spell Fail
          </under-input>
        </div>
        <div class="col text-center">
        </div>
      </div>
      <armor-detail :armorClass="armorClass.natural">Natural</armor-detail>
      <armor-detail :armorClass="armorClass.deflection">Deflection</armor-detail>
      <armor-detail :armorClass="armorClass.dodge">Dodge</armor-detail>
      <armor-detail :armorClass="armorClass.magic">Magic</armor-detail>
      <armor-detail :armorClass="armorClass.misc">Miscellaneous</armor-detail>
      <div class="row" v-if="size && $rpgv.d20.size[size].modifier != 0">
        <div class="col-2 text-center">
          <under-text>
            <div slot="underline">{{ $rpgv.d20.size[size].modifier }}</div>
            Bonus
          </under-text>
        </div>
        <div class="col">
          <under-text>
            <div slot="underline">{{ size }}</div>
            Size
          </under-text>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState } from "vuex";
import ArmorDetail from "./_ArmorDetail.vue";
import UnderCheckbox from "../../shared/_UnderCheckbox.vue";
import UnderInput from "../../shared/_UnderInput.vue";

export default {
  name: "sections-defenses-details-fifth-pfrpg",
  components: {
    ArmorDetail,
    UnderCheckbox,
    UnderInput
  },
  props: ["toggleState"],
  computed: mapState({
    size: state => state.characters.current.core.size,
    armorClass: state => state.characters.current.defense.armorClass
  })
};
</script>
